import { createSelector } from '@reduxjs/toolkit';

import type { AIVoiceFilter } from 'js/src/client';
import { AIVoiceFilterTypeEnum } from 'js/src/client';
import type { RootState } from 'js/src/libs/RootState';

function getAIVoiceFiltersState(state: RootState) {
    return state.aiVoicesAndAvatars.aiVoiceFilters;
}

const createFilterSelector = (filterType: AIVoiceFilterTypeEnum) =>
    createSelector(
        (state: RootState) => getAIVoiceFiltersState(state).data[filterType],
        (data): AIVoiceFilter[] => data.allIds.map((id) => data.byId[id]),
    );

export const getAIVoiceLanguageFilters = createFilterSelector(AIVoiceFilterTypeEnum.LANGUAGE);
export const getAIVoiceAccentFilters = createFilterSelector(AIVoiceFilterTypeEnum.ACCENT);
export const getAIVoiceToneFilters = createFilterSelector(AIVoiceFilterTypeEnum.TONE);
export const getAIVoiceStyleFilters = createFilterSelector(AIVoiceFilterTypeEnum.STYLE);
export const getAIVoiceAgeFilters = createFilterSelector(AIVoiceFilterTypeEnum.AGE);
export const getAIVoiceGenderFilters = createFilterSelector(AIVoiceFilterTypeEnum.GENDER);
export const getAIVoiceQualityFilters = createFilterSelector(AIVoiceFilterTypeEnum.QUALITY);

function getAIVoiceFiltersRequestState(state: RootState) {
    return getAIVoiceFiltersState(state).request;
}

export function getAIVoiceFiltersRequestIsUninitialized(state: RootState): boolean {
    return getAIVoiceFiltersRequestState(state).status === 'uninitialized';
}

export function getAIVoiceFiltersRequestIsPending(state: RootState): boolean {
    return getAIVoiceFiltersRequestState(state).status === 'pending';
}
